import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { classNames } from '../../utils';

function Websites({ websites }) {
  return (
    <div className="search-facet-group">
      <h2 className="search-facet-group__title">{websites?.Label}</h2>
      <ul role="list">
        {websites?.Items?.map((item, index) => (
          <li key={index}>
            <a
              href={!item.Current ? item.Url : undefined}
              className={classNames(
                'search-facet-group__website-link',
                item?.Current && 'search-facet-group__website-link--current'
              )}
              aria-current={item.Current ? 'page' : false}
            >
              {item?.Label} ({item?.Count})
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
}

Websites.propTypes = {
  websites: PropTypes.shape({
    Label: PropTypes.string.isRequired,
    Items: PropTypes.arrayOf(
      PropTypes.shape({
        Label: PropTypes.string,
        Count: PropTypes.number,
        Url: PropTypes.string,
        Current: PropTypes.bool
      })
    ).isRequired
  }).isRequired
};

export default memo(Websites);
